import React, {FC} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {Box, Typography} from '@mui/material'
import {useSnackbar} from 'notistack'

import {ReactComponent as ExpiredImage} from '@progyny/assets/images/fail-link.svg'
import SubmitButton from '@progyny/components/Buttons/SubmitButton'
import SimpleMessageContainer from '@progyny/components/SimpleMessageContainer'
import {useResendPrivateEmailConfirmationMutation} from '@progyny/generated/graphql'
import {useErrorCodes} from '@progyny/hooks/useErrorCodes'
import {RouteEnum, useRoutes} from '@progyny/routes'

const TokenExpiredPage: FC = () => {
  const {t} = useTranslation('ErrorPages')
  const {enqueueSnackbar} = useSnackbar()
  const getErrorMessage = useErrorCodes()
  const history = useHistory()
  const [resend, {loading}] = useResendPrivateEmailConfirmationMutation()
  const {getPath} = useRoutes()

  const handleResendConfirmation = () => {
    resend()
      .then((resendResult) => {
        const data = resendResult.data!.resendPrivateEmailConfirmation
        const success = Boolean(data?.success)
        const errorCode = data!.errorCode as string
        if (!success) {
          enqueueSnackbar({
            message: getErrorMessage(errorCode),
            variant: 'error',
          })
          if (errorCode === 'user-not-logged-in') {
            history.push(getPath(RouteEnum.LOGIN))
          }
        } else {
          enqueueSnackbar({
            message: t('profile_personal_info_confirmation_email_sent'),
            variant: 'success',
          })
        }
      })
      .catch((reason) => {
        enqueueSnackbar({
          message: t(
            'home_confirmation_box_errors_unable_to_resend_confirmation'
          ),
          variant: 'error',
        })
      })
  }

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      height={'100vh'}
    >
      <SimpleMessageContainer
        image={ExpiredImage}
        actionArea={
          <SubmitButton onClick={handleResendConfirmation} loading={loading}>
            {t('confirm_email_resend_email')}
          </SubmitButton>
        }
        message={
          <Box textAlign={'center'}>
            <Typography variant={'h1'}>
              {t(
                'partners_agreement_partner_agreement_error_something_went_wrong'
              )}
            </Typography>
            <Typography variant={'body2'} mt={2}>
              <Trans i18nKey='token_expired_your_account_setup_link_was' />
            </Typography>
          </Box>
        }
      />
    </Box>
  )
}

export default TokenExpiredPage
